import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { UserX } from "lucide-react";

const STATUSES = ["Bekliyor", "İşlemde", "Tamamlandı"];
const STATUS_STYLE = {
  Bekliyor: "bg-[#D4AF37]/15 text-[#8a6d00]",
  "İşlemde": "bg-[#40916C]/15 text-[#2D6A4F]",
  "Tamamlandı": "bg-[#1B4D2E]/15 text-[#1B4D2E]",
};

export default function DeletionsTab() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/deletion-requests").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const patch = async (id, payload) => {
    setItems((arr) => arr.map((m) => (m.id === id ? { ...m, ...payload } : m)));
    try { await api.patch(`/admin/deletion-requests/${id}`, payload); } catch { toast.error("Güncellenemedi."); }
  };

  const saveNote = async (id, admin_note) => {
    try { await api.patch(`/admin/deletion-requests/${id}`, { admin_note }); toast.success("Not kaydedildi."); } catch { toast.error("Kaydedilemedi."); }
  };

  if (!items.length) return (
    <div className="rounded-2xl border border-dashed border-[#E2E8E4] bg-white py-16 text-center">
      <UserX className="h-10 w-10 text-[#E2E8E4] mx-auto" />
      <p className="text-[#5C6F62] mt-3">Henüz hesap silme talebi yok.</p>
    </div>
  );

  return (
    <div className="space-y-4">
      {items.map((m, i) => (
        <div key={m.id} data-testid={`deletion-item-${i}`} className="rounded-2xl border border-[#E2E8E4] bg-white p-5">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <div className="flex items-center gap-3">
                <p className="font-semibold text-[#1A251E]">{m.name}</p>
                <span className="font-mono-accent text-xs px-2 py-0.5 rounded bg-[#F8F9FA] border border-[#E2E8E4] text-[#5C6F62]">{m.ticket}</span>
              </div>
              <p className="text-sm text-[#40916C]">{m.email}{m.username ? ` · @${m.username}` : ""}</p>
            </div>
            <select value={m.status} onChange={(e) => patch(m.id, { status: e.target.value })} data-testid={`deletion-status-${i}`} className={`rounded-full px-3 py-1.5 text-xs font-semibold border-0 ${STATUS_STYLE[m.status] || ""}`}>
              {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          {m.reason && <p className="mt-3 text-[#37473d] text-sm border-t border-[#E2E8E4] pt-3"><span className="text-[#9aa89f] font-mono-accent text-xs uppercase mr-2">Neden</span>{m.reason}</p>}
          <div className="mt-3">
            <textarea
              rows={2}
              defaultValue={m.admin_note}
              onBlur={(e) => e.target.value !== m.admin_note && saveNote(m.id, e.target.value)}
              data-testid={`deletion-note-${i}`}
              placeholder="Admin notu ekle (odak dışına çıkınca kaydedilir)..."
              className="sr-input resize-none text-sm"
            />
          </div>
          <p className="mt-2 font-mono-accent text-[11px] text-[#9aa89f]">{new Date(m.created_at).toLocaleString("tr-TR")}</p>
        </div>
      ))}
    </div>
  );
}
